import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as Logo } from '../../images/Logo.svg';
import { Menu, X } from 'lucide-react'; // Іконки бургер-меню
import css from './Header.module.css';

const Header = () => {
	const location = useLocation();
	const [isOpen, setIsOpen] = useState(false);

	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		setIsOpen(false);
	};

	return (
		<header className={css.header}>
			<div className={css.container}>
				<Link to="/" onClick={scrollToTop}>
					<Logo />
				</Link>

				<button className={css.burger} onClick={toggleMenu}>
					{isOpen ? <X size={28} /> : <Menu size={28} />}
				</button>

				<nav className={`${css.nav} ${isOpen ? css.navOpen : ''}`}>
					<ul className={css.navList}>
						<li className={css.navItem}>
							<NavLink
								to="/"
								className={`${css.navLink} ${location.pathname === '/' ? css.active : ''}`}
								onClick={scrollToTop}
							>
								Strona główna
							</NavLink>
						</li>
						<li className={css.navItem}>
							<NavLink
								to="/o-nas"
								className={`${css.navLink} ${location.pathname === '/o-nas' ? css.active : ''}`}
								onClick={scrollToTop}
							>
								O nas
							</NavLink>
						</li>
						<li className={css.navItem}>
							<NavLink
								to="/oferta"
								className={`${css.navLink} ${location.pathname === '/oferta' ? css.active : ''}`}
								onClick={scrollToTop}
							>
								Oferta
							</NavLink>
						</li>
						<li className={css.navItem}>
							<NavLink
								to="/kontakt"
								className={`${css.navLink} ${location.pathname === '/kontakt' ? css.active : ''}`}
								onClick={scrollToTop}
							>
								Kontakt
							</NavLink>
						</li>
						<li className={css.navItemLast}>
							<NavLink to="/kontakt" className={css.navLinkLast} onClick={scrollToTop}>
								Umów się
							</NavLink>
						</li>
					</ul>
				</nav>
			</div>
		</header>
	);
};

export default Header;
